import { JourneyTrack } from "../journey-track";
import { TrackInfo } from "../model/track-info";
import { TrackTypes } from "../model/track-types";
import { DomainOrigin } from "../../../domains/model/domain-origin";
import { TrackActionResult } from "../model/track-action-result";
import { environment } from "../../../../../../environments/environment";
import { ContaIonDataParse } from "./util/conta-ion-data-parse";
import { CacheService } from "../../../comunicator-native/cache/v2/cache.service";
import { MobileMockData } from "./util/mobile-mock-data";
import { Platform } from "@ionic/angular";

export class ContaIonIncomeTrack extends JourneyTrack {
  readonly originalTracks = [
    new TrackInfo("income-wealthincome", ["income", "income-wealthincome"]),
    new TrackInfo("income-patrimony", ["income", "patrimony"]),
    new TrackInfo("income-tax-residency", ["income", "tax-residency"]),
    new TrackInfo(
      "income-tax-residency-country",
      ["income", "tax-residency-country"],
      undefined,
      { domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin] }
    ),
    new TrackInfo("income-nif", ["income", "nif"]),
    new TrackInfo("income-date-tax-res", ["income", "date-tax-residency"]),
  ];

  track = [];

  constructor(
    private cacheNativeService: CacheService,
    private platform: Platform
  ) {
    super();
    this.track = this.originalTracks;
  }

  getName(): TrackTypes {
    return TrackTypes.CONTA_ION_INCOME;
  }

  getTrack(): TrackInfo[] {
    return this.track;
  }

  public async loadData() {
    //MobileMockData.executeMockCall(500);
    const data = await this.cacheNativeService.getItemCommunicator();
    return Promise.resolve(ContaIonDataParse.parseFromMobileData(data));
  }

  public isUncoupled() {
    return true;
  }

  isEventComunicator() {
    return true;
  }

  public executeAction(actionName, data): TrackActionResult {
    throw new Error("Esta track não possui actions");
  }

  isBackHeader() {
    return this.platform.is("android");
  }
}

export enum ActionList {}
